import {Component, Input, OnInit} from '@angular/core';
import {BowkerMetadata, CatalogRecord} from '@raven';

@Component({
  selector: 'rn-catalog-details-summary-tab',
  templateUrl: './catalog-details-summary-tab.component.html',
  styleUrl: './catalog-details-summary-tab.component.scss',
  standalone: false
})
export class CatalogDetailsSummaryTabComponent implements OnInit {
  otherFormats: Array<object>;
  otherFormatCount = 1;
  meta: object;

  @Input() metadata: BowkerMetadata;
  @Input() catalogRecord: CatalogRecord;

  ngOnInit(): void {
    this.setupMockData();
  }

  setupMockData(): void {
    this.meta = {
      thumbnailImageUrl:
        'https://images-na.ssl-images-amazon.com/images/I/81XWWgotqvL.jpg',
      rating: 2.5,
      ratingCount: 88,
      favorite: false,
    };

  }
}
